class Header {
    constructor() {
        $(() => {
            this.setMiniProfile();
        })

        this.events();
    }

    events() {
        $(document)
            .on('ajax.update.success', () => {
                this.setMiniProfile();
            })
            .on('click', '[burger-open]', () => {
                this.burgerOpen();
            })
            .on('click', '[burger-close]', () => {
                this.burgerClose();
            });

        $(window).on('scroll', () => {
            if ($(window).scrollTop() > 10 || $('body').hasClass('modal-open')) {
                this.stickyAdd();
            } else {
                this.stickyDel();
            }
        });

        if ($(window).scrollTop() > 10) {
            this.stickyAdd();
        }

        this.scrollPage();
    }

    stickyAdd() {
        $(".header").addClass('header-sticky');
        $(".mobile-menu").addClass('header-sticky');
    }

    stickyDel() {
        $(".header").removeClass('header-sticky');
        $(".mobile-menu").removeClass('header-sticky');
    }

    scrollPage() {
        var scrollPos = 0;

        $(window).on("scroll", () => {
            var st = $(window).scrollTop();

            if (st > 100) {
                $(".mobile-menu__header").addClass("sticky-mobmenu-header");

                if (st > scrollPos) {
                    $(".header").addClass("sticky-header-up");
                } else {
                    $(".header").removeClass("sticky-header-up");
                }
            } else {
                $(".header").removeClass("sticky-header-up");
                $(".mobile-menu__header").removeClass("sticky-mobmenu-header");
            }

            scrollPos = st;
        });
    }

    setMiniProfile() {
        // setAvatarColors
        var bg_color = $('header .user-avatar__login').length ? User.avatarColor() : '#eee';

        $('header .user-avatar').css({
            'background-color': bg_color,
            'opacity': 0.9
        });

        $('header .user-avatar__login').css('color', User.avatarTextColor());

        // setName
        $('header .user-name').html(User.full_name).parents('.user-dropdown:eq(0)').addClass('show');
        if ($('header .user-name').width() > 210) {
            var name_arr = User.full_name.split(' ');
            $('header .user-name').html(name_arr[0]);
        }
        $('header .user-name').parents('.user-dropdown:eq(0)').removeClass('show');
    }

    burgerOpen() {
        $('.mobile-menu').addClass('is-mobile-menu-active');
        $('body').addClass('overflow-hidden');
    }

    burgerClose() {
        $('.mobile-menu').removeClass('is-mobile-menu-active');
        $('body').removeClass('overflow-hidden');
    }
}

export default new Header();